var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcDeleteTrash = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "prefix__a9",
    d: "M4.667.333L4 1H.667v1.333h10.666V1H8L7.333.333H4.667zM1.333 3.667v8.666c0 .734.6 1.334 1.334 1.334h6.666c.734 0 1.334-.6 1.334-1.334V3.667H1.333zm2 1.333h1.334v7.333H3.333V5zm4 0h1.334v7.333H7.333V5z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(2 1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__b9",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__a9"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    fillRule: "nonzero",
    xlinkHref: "#prefix__a9"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    mask: "url(#prefix__b9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H33.333V33.333H0z",
    transform: "translate(-10.667 -9.667)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcDeleteTrash, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-delete-trash.d5543486.svg";
export { ForwardRef as ReactComponent };